import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resources } from '../models/constants';
import { Credentials } from '../models/credentials.model';
import { CredentialsService } from '@shared/services/credentials.service';

@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  private readonly credentialsService = inject(CredentialsService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwt: string = this.getJwt();

    // Create headers with Authorization Bearer token.
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Check if jwt has a value, and then add the Authorization header.
    if (jwt) {
      headers = headers.append('Authorization', `Bearer ${jwt}`);
    }

    // Clone the request and include the headers.
    let modifiedRequest = request.clone({ headers });

    // Prepend environment.serverUrl to requests without http/https.
    if (!/^(http|https):/i.test(modifiedRequest.url)) {
      modifiedRequest = modifiedRequest.clone({ url: modifiedRequest.url });
    }

    return next.handle(modifiedRequest);
  }

  private getJwt(): string {
    this.checkImpersonation();

    const cachedItem = localStorage.getItem(Resources.CredentialsKey);

    if (cachedItem) {
      const cachedData: Credentials = JSON.parse(cachedItem);
      return cachedData.jwt || '';
    }

    return '';
  }

  private checkImpersonation() {
    if (this.getCookie('clientAccessId') && this.getCookie('jwt')) {
      localStorage.removeItem('state');
      const newClientAccessId = this.getCookie('clientAccessId');
      const newJwt = this.getCookie('jwt');
      this.deleteCookie('clientAccessId');
      this.deleteCookie('jwt');
      const newCredentials: Credentials = {
        clientAccessId: newClientAccessId!!,
        jwt: newJwt,
      };

      this.credentialsService.setCredentials(newCredentials);
      window.location.href = '/';
    }
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.split('; ').find((row) => row.startsWith(name + '='));

    return match ? match.split('=')[1] : null;
  }

  private deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=enrollandpay.com`;
  }
}
